var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app__select" },
    [
      _c("div", {
        class: {
          app__diamond: true,
          "app__diamond--top": true,
          "app__diamond--green": _vm.currentStep == 1,
          "app__diamond--white": _vm.currentStep != 1
        }
      }),
      _vm._v(" "),
      _c("Close"),
      _vm._v(" "),
      _c("div", { staticClass: "app__selectWrapper" }, [
        _c(
          "div",
          { staticClass: "app__selectInner" },
          [
            _c("StepLabel", { attrs: { step: _vm.step.step_number } }),
            _vm._v(" "),
            _c("Steps", {
              attrs: {
                "max-steps": _vm.maxSteps,
                "active-step": _vm.step.step_number,
                steps: _vm.steps
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "app__selectBoxWrapper" }, [
              _c("div", {
                staticClass: "app__selectTitle",
                domProps: { innerHTML: _vm._s(_vm.step.title) }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "app__selectBoxes" },
                _vm._l(_vm.step.selects, function(select, index) {
                  return _vm.step.selects
                    ? _c("div", { staticClass: "app__selectBox" }, [
                        _c("img", {
                          attrs: {
                            src: select.image.path,
                            alt: select.image.title
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "app__selectBoxButton" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn__primary",
                              on: {
                                click: function($event) {
                                  return _vm.setPath(index)
                                }
                              }
                            },
                            [_vm._v(_vm._s(select.label_text))]
                          )
                        ])
                      ])
                    : _vm._e()
                }),
                0
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", {
        class: {
          app__diamond: true,
          "app__diamond--bottom": true,
          "app__diamond--red": _vm.currentStep == 1,
          "app__diamond--green2": _vm.currentStep != 1
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }